import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StudentHelperService } from '../service/student-helper.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'view-child',
    templateUrl: './view-child.component.html',
    styleUrls: ['./view-child.component.scss']
})
export class ViewChildComponent implements OnInit {
    studentName: string;
    msdNumber: string = '';
    regions: string;
    terminated: string;
    merged: string;
    studentId: number;
    isMerged: boolean = false;
    isLoading: boolean = false;

    subs: Subscription[] = [];

    constructor(private route: ActivatedRoute, private studentHelper: StudentHelperService) {
        this.subscriptions();
    }

    ngOnInit(): void {
        this.isLoading = true;

        let studentIdString = this.route.snapshot.paramMap.get('studentId') || '';

        if (studentIdString) {
            this.studentId = parseInt(studentIdString);
            this.studentHelper.setStudentId(this.studentId);
        }

        this.isLoading = false;
    }

    subscriptions() {
        let studentNameSub = this.studentHelper.studentName$.subscribe((studentName) => {
            this.studentName = studentName;
        });

        this.subs.push(studentNameSub);

        let regionsSub = this.studentHelper.regions$.subscribe((regions) => {
            this.regions = regions;
        });

        this.subs.push(regionsSub);

        let terminatedSub = this.studentHelper.terminated$.subscribe((terminated) => {
            this.terminated = terminated;
        });

        this.subs.push(terminatedSub);

        let mergedSub = this.studentHelper.merged$.subscribe((merged) => {
            this.merged = merged;
        });

        this.subs.push(mergedSub);

        let isMergedSub = this.studentHelper.isMerged$.subscribe((isMerged) => {
            this.isMerged = isMerged;
        });

        this.subs.push(isMergedSub);

        let msdNumberSub = this.studentHelper.msdNumber$.subscribe((msdNumber) => {
            this.msdNumber = msdNumber;
        });

        this.subs.push(msdNumberSub);
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }
}
